<template>
    <div class="anchor-navigation two-cols grid grid__base" :class="rootClasses" ref="anchorNavigation">
        <div class="two-cols--container grid--container">
            <div class="two-cols--row grid--row">
                <div class="two-cols--main grid--col anchor-navigation--col">
                    <div class="grid--row">
                        <div class="grid--col anchor-navigation--nav anchor-navigation--nav__dark">
                            <div aria-hidden="true"
                                    class="anchor-navigation--nav-container anchor-navigation--nav-container__hidden u--reset"
                                    ref="navWrapper">
                                <div
                                        class="u-reset anchor-navigation--link"
                                        v-for="link in navItems"
                                        :key="link.id"
                                        ref="hiddenLinks">
                                    {{ link.title }}
                                </div>
                            </div>
                            <nav class="anchor-navigation--nav-container">
                                <a :href="`#${link.hook}`"
                                        :data-hook="link.hook"
                                        class="u-reset anchor-navigation--link"
                                        :class="[bemAdd(i === activeItemIndex ? 'active' : 'base', 'link')]"
                                        v-for="(link, i) in menuItems.links"
                                        :key="link.id"
                                        ref="links">{{ link.title }}</a>
                                <anchor-navigation-dropdown :items="menuItems.dropdown"
                                        :active-item-index="activeDropdownItemIndex"
                                        v-if="menuItems.dropdown.length"/>
                                <div class="anchor-navigation--indicator" :style="computeIndicator"/>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AnchorNavigationDropdown from './anchor-navigation-dropdown/anchor-navigation-dropdown';
    import { bemMixin, isMountedMixin } from '@dreipol/vue-ui/src/mixins';
    import { mapState } from 'vuex';
    import { elementOffsetTop } from 'bianco.viewport';
    import $ from 'bianco.query';

    export default {
        components: { AnchorNavigationDropdown },
        mixins: [bemMixin('anchor-navigation'), isMountedMixin],
        props: {
            facets: {
                type: Array,
                default() {
                    return ['base'];
                },
            },
        },
        data() {
            return {
                navItems: [
                    {
                        id: String,
                        title: String,
                        hook: String,
                    },
                ],
                hookElements: Array,
                activeItemIndex: null,
                triggeredItemIndex: null,
            };
        },
        computed: {
            menuItems() {
                this.viewportWidth; // eslint-disable-line
                if (!this.isMounted) {
                    return { links: [], dropdown: [] };
                }

                const wrapperWidth = this.$refs.navWrapper.offsetWidth;

                let totalWidth = 0;
                return this.navItems.reduce((acc, item, index) => {
                    totalWidth += this.$refs.hiddenLinks[index].offsetWidth + 24;
                    totalWidth <= wrapperWidth ? acc.links.push(item) : acc.dropdown.push(item);
                    return acc;
                }, { links: [], dropdown: [] });
            },
            ...mapState('vue-ui/scroll', {
                scrollPosition: 'position',
            }),
            ...mapState('viewport', {
                viewportWidth: 'width',
            }),
            anchorOffsets() {
                // this.viewportWidth here is only needed to compute this function whenever the viewport changes
                // without it vue will never update this value
                this.viewportWidth; // eslint-disable-line
                this.isMounted; // eslint-disable-line
                return this.hookElements.map(s => Math.floor(elementOffsetTop(s)));
            },
            rootClasses() {
                return [
                    this.bemIf(this.navItems.length > 0, 'is-visible', 'is-hidden'),
                ];
            },
            computeIndicator() {
                this.isMounted && this.viewportWidth; // eslint-disable-line

                const { links } = this.$refs;

                const activeIndex = this.triggeredItemIndex === null ? this.activeItemIndex : this.triggeredItemIndex;

                const activeLinkItem = links && links[activeIndex];

                return activeLinkItem ? {
                    width: `${ activeLinkItem.offsetWidth }px`,
                    left: `${ activeLinkItem.offsetLeft }px`,
                } : {};
            },
            activeDropdownItemIndex() {
                return this.activeItemIndex - (this.menuItems.links.length);
            },
        },
        methods: {
            setActiveIndex(index) {
                this.triggeredItemIndex = index;
            },
            onScroll(scrollPosition) {
                // reverse all the anchor offsets to find the active index starting from the last one
                const activeIndex = [...this.anchorOffsets].reverse().findIndex(o => scrollPosition >= o);
                // the right active index must be remapped because we have reversed the anchorOffsets list
                // the findIndex method will give use always the inverse index of the current active menu item
                const mapIndex = index => (this.anchorOffsets.length - 1) - index;
                // if an active index was found we map it to the proper one otherwise we fall back to the first item
                this.activeItemIndex = activeIndex > -1 ? mapIndex(activeIndex) : null;
            },
        },
        watch: {
            scrollPosition(value) {
                this.onScroll(value);
            },
        },
        beforeMount() {
            this.hookElements = $('.anchor-placeholder--hook');
            const titleElements = $('.anchor-placeholder--title');

            this.navItems = this.hookElements.reduce((acc, current, index) => {
                acc.push({ hook: current.id, title: titleElements[index].innerHTML, id: index });
                return acc;
            }, []);
        },
        mounted() {
            if (this.navItems.length <= 0) {
                return;
            }

            // set a global class on the html tag needed for the styling of other components
            document.documentElement.classList.add('has-anchor-navigation');

            this.onScroll(this.scrollPosition);
        },
    };
</script>
